import api from '@mint-lib/api';
import { useMutation, useQueryClient } from '@mint-lib/query-client';

import { GET_BUILDER_TABLE_VIEW } from '../constants/EndpointConstants.js';
import { QueryKey } from '../constants/queryKeys.js';
import {
  BuilderTableViewResponseSchema,
  type BuilderTableViewResponse,
} from '../types/builderTableView.js';

type SaveColumnOrderData = {
  id: number;
  columns: { name: string }[];
};
type SaveColumnWidthData = {
  id: number;
  columnWidth: { [name: string]: number };
};

const saveColumnOrderData = async ({ id, columns }: SaveColumnOrderData) => {
  const response = await api.patch(`${GET_BUILDER_TABLE_VIEW}${id}/`, {
    columns,
  });
  return BuilderTableViewResponseSchema.parse(response.data);
};
const saveColumnWidthData = async ({
  id,
  columnWidth,
}: SaveColumnWidthData) => {
  const response = await api.patch(`${GET_BUILDER_TABLE_VIEW}${id}/`, {
    columnWidth,
  });
  return BuilderTableViewResponseSchema.parse(response.data);
};

export const useSaveBuilderTableColumnOrder = () => {
  const queryClient = useQueryClient();
  const saveBuilderTableColumnOrder = useMutation({
    mutationFn: (data: SaveColumnOrderData) => saveColumnOrderData(data),
    onSuccess: (data: BuilderTableViewResponse) => {
      queryClient.setQueryData(
        [QueryKey.BUILDER_TABLE_VIEW, String(data.campaignCollection)],
        data,
      );
    },
  });

  return saveBuilderTableColumnOrder.mutateAsync;
};

export const useSaveBuilderTableColumnWidth = () => {
  const queryClient = useQueryClient();
  const saveBuilderTableColumnWidth = useMutation({
    mutationFn: (data: SaveColumnWidthData) => saveColumnWidthData(data),
    onSuccess: (data: BuilderTableViewResponse) => {
      queryClient.setQueryData(
        [QueryKey.BUILDER_TABLE_VIEW, String(data.campaignCollection)],
        data,
      );
    },
  });

  return saveBuilderTableColumnWidth.mutateAsync;
};
